import type { Theme } from '@mui/material';

export const styles = {
  headline: (theme: Theme) => ({
    color: theme.colors.neutral[400],
    lineHeight: '2.25rem',
    fontSize: 20,
    fontWeight: 700,
  }),

  headlineId: (theme: Theme) => ({
    color: theme.colors.black,
  }),
};
